'use client';

import { useTranslations } from 'next-intl';
import { ComponentPropsWithRef } from 'react';
import { ITEM_NOTE_MAX_LENGTH } from '@/shared/config/constants/notes';
import { Optional } from '@/shared/model/Optional';
import { Form } from '@/shared/ui/form';
import './product-detail.scss';

type Props = Optional<ComponentPropsWithRef<typeof Form.TextArea>, 'name'> & {
    className?: string;
};
export const ProductMenuNote = ({ className, rules, ...props }: Props) => {
    const t = useTranslations();
    return (
        <div className={className}>
            <Form.TextArea
                name="note"
                label={t('WORDS.ITEM_NOTE')}
                {...props}
                rules={{ ...rules, maxLength: ITEM_NOTE_MAX_LENGTH }}
            />
        </div>
    );
};
